"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactActionsDesktop = require("./ContactActionsDesktop");
Object.keys(_ContactActionsDesktop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactActionsDesktop[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactActionsDesktop[key];
    }
  });
});